


const APIHOST = (process.env.NODE_ENV === "development1") ? "http://localhost:3000/dev" : "https://api.streempay.com";

export function createUser(userData, token) {
    userData.account_type = "user";
    console.log('CREATING USER....', userData);
    return fetch(APIHOST + "/user", {
            method: 'POST', 
            body: JSON.stringify(userData),
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => {
          return res.json();
        });
}

export function createUserPaymentMethod(userId, paymentMethodData, token) {
  console.log('CREATING PAYMENT METHOD....', paymentMethodData);
  return fetch(APIHOST + "/user/"+userId+"/payment-method", {
          method: 'POST', 
          body: JSON.stringify(paymentMethodData),
          headers: {
            'Authorization': token, 
            'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function getUserMe(token) {
  console.log('GETTING ME...', token);
  return fetch(APIHOST + "/user/me", {
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function getUser(userId, token) {
    console.log('GETTING USER...' + userId, token);
    return fetch(APIHOST + "/user/" + userId, {
            headers: {
                'Authorization': token, 
                'Content-Type': 'application/json'
            }
        })
        .then(res => {
          return res.json();
        });
}

export function updateUser(userId, userData, token) {
    console.log('UPDATING USER....', userId, userData);
    return fetch(APIHOST + "/user/" + userId, {
            method: 'PUT', 
            body: JSON.stringify(userData),
            headers: {
                'Authorization': token, 
                'Content-Type': 'application/json'
            }
        })
        .then(res => {
          return res.json();
        });
}

export function getUserBudgets(userId, token) {
  console.log('GETTING USER BUDGETS...' + userId, token);
  return fetch(APIHOST + "/user/" + userId + '/budgets', {
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function createUserBudget(userId, budgetData, token) {
  console.log('CREATING USER BUDGETS...' + userId, token);
  return fetch(APIHOST + "/user/" + userId + '/budgets', {
          method: 'POST', 
          body: JSON.stringify(budgetData),
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function deleteUserBudget(userId, budgetId, token) {
  console.log('DELETING USER BUDGET...' + userId, token);
  return fetch(APIHOST + "/user/" + userId + '/budgets/' + budgetId, {
          method: 'DELETE', 
          body: '',
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function getUserTracking(userId, period, token) {
  console.log('GETTING USER TRACKING...' + userId, period, token);
  return fetch(APIHOST + "/user/" + userId + '/tracking?period=' + period, {
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function migrateUserTracking(userId, token) {
  console.log('MIGRATING USER TRACKING...' + userId, token);
  return fetch(APIHOST + "/tracking/migrate/" + userId, {
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}

export function getUserInvoices(userId, token) {
  console.log('GETTING USER INVOICES...' + userId, token);
  return fetch(APIHOST + "/user/" + userId + '/invoices', {
          headers: {
              'Authorization': token, 
              'Content-Type': 'application/json'
          }
      })
      .then(res => {
        return res.json();
      });
}